export class FullServiceCustomerType {
    ID: number;
    Name: string;
}

export default FullServiceCustomerType;